module.exports = __webpack_public_path__ + "img/slide-9-3.015435a2.jpg";